<template>
  <v-card flat>
    <v-row class="mx-auto text-center py-0" justify="center" no-gutters>
      <v-col>
        {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.general.eventStart') }}: {{ eventStartTime }}
      </v-col>
      <v-col>
        {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.general.eventEnd') }}: {{ eventEndTime }}
      </v-col>
    </v-row>
    <v-row class="mx-auto text-center py-0" justify="center" no-gutters>
      <v-col>
        {{ this.event.recommendationName }} <span class="caption">({{ this.recommendationNameLocalized }})</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vuetify from '../../../plugins/vuetify'

import { createHelpers } from 'vuex-map-fields'
import { AUTH_MODULE } from '../../../store/modules'
import { CriticalEvent } from '../../../models/map/CriticalEvent'

const { mapFields: authFields } = createHelpers({
  getterType: `${AUTH_MODULE}/getField`
})

export default {
  name: 'criticalGeneral',
  props: {
    event: CriticalEvent,
    rawValues: Boolean,
    nanoUser: Boolean
  },
  computed: {
    ...authFields(['isSpecial', 'isAdmin']),
    recommendationNameLocalized () {
      const key = `$vuetify.map.criticalPopup.recommendations.${this.event.recommendationName}`
      const result = Vuetify.framework.lang.t(key)
      return result !== key ? result : null
    },
    debugMode () {
      return this.isAdmin && this.rawValues
    },
    eventStartTime () {
      return !this.debugMode ? this.event.formattedTimeEventStart : this.event.timeEventStart.getTime()
    },
    eventEndTime () {
      return !this.debugMode ? this.event.formattedTimeEventEnd : this.event.timeEventEnd.getTime()
    },
  },
  data: () => ({
    search: '',
  })
}
</script>

<style scoped>
  .wrap_words {
    word-wrap: break-word;
    max-width: 250px;
    display: inline-block;
  }
</style>
